import GradientButton from "../../../components/GradientButton/GradientButton";
import "./Week10.scss";
import { GradientButtonType } from "../../../models/GradientButtonType";

const Week10 = () => {

  
  return (
    <div className="week10">
      <h1>Clues</h1>
      <div className="button-wrapper">
        <GradientButton
          label="Free Word"
          type={GradientButtonType.Purple}
          onClick={() => {
            window.open(
              "https://x.com/SkillfulAI/status/1765206850570510672?s=20",
              "_blank"
            );
          }}
        />
        <GradientButton
          label="Puzzle"
          type={GradientButtonType.Purple}
          onClick={() => {
            window.open(
              "https://x.com/SkillfulAI/status/1765963384015761695?s=20",
              "_blank"
            );
          }}
        />

        <GradientButton
          label="Puzzle"
          type={GradientButtonType.Purple}
          onClick={() => {
            window.open(
              "https://x.com/SkillfulAI/status/1767057959610196349?s=20",
              "_blank"
            );
          }}
        />
      </div>
     
    </div>
  );
};

export default Week10;
